module.exports = __webpack_public_path__ + "img/sd.5207388c.svg";